import { PortableText } from '@portabletext/react';
import styles from './styles.module.scss';
import { portableTextComponents } from '@/lib/portableTextComponents';

export function TextBlock({ children, title, text, maxWidth, textAlignment, backgroundType, backgroundColor, backgroundGradient, backgroundPosition }) {
  const cleanedBackgroundType = backgroundType || null;
  const cleanedBackgroundColor = backgroundColor || null;
  let styleObject = { maxWidth: maxWidth || '100%' };
  const backgroundStyleObject = {};

  if (cleanedBackgroundType === "solid" && cleanedBackgroundColor !== null) backgroundStyleObject.backgroundColor = `rgba(${backgroundColor.rgb.r},${backgroundColor.rgb.g},${backgroundColor.rgb.b},${backgroundColor.rgb.a})`
  if (cleanedBackgroundType === "gradient" && backgroundGradient?.length > 0) {
    const gradientColors = backgroundGradient.map((color) => `rgba(${color.color.rgb.r},${color.color.rgb.g},${color.color.rgb.b},${color.color.rgb.a})`);
    backgroundStyleObject.background = `linear-gradient(90deg, ${gradientColors.join(", ")})`;
  }

  if (backgroundPosition === "contained") {
    styleObject = { ...styleObject, ...backgroundStyleObject };
  }

  return (
    <section className={`${styles.textBlock} ${styles[textAlignment]} ${styles[`background--${backgroundPosition}`]}`} style={styleObject}>
      {backgroundPosition === "fullWidth" && <div className={styles.backgroundPlaceholder} style={backgroundStyleObject} />}
      {title && <h2 className={styles.title}>{title}</h2>}
      <div className={`${styles.content} ${styles[textAlignment]}`}>
        {children ? children :
          <PortableText
            value={text}
            components={portableTextComponents}
          />
        }
      </div>
    </section>
  );
}